import { withInstall } from '@bigin/utils'
import Calendar from './src/calendar.vue'

export const BCalendar = withInstall(Calendar)
export default BCalendar

export * from './src/calendar'
